import { IComponentOptions } from "angular";
import { MachineConfigurationTypeDetailGameViewComponentController } from "./controller";

export const vsComponentName =
  "machineConfigurationTypeDetailGameViewComponent";

export const machineConfigurationTypeDetailGameViewComponentOptions: IComponentOptions =
  {
    controller: MachineConfigurationTypeDetailGameViewComponentController,
    controllerAs: "gameViewController",
    template: require("!html-loader!./index.html").default,
    bindings: {
      machineConfigurationType: "<",
      games: "<",
    },
  };
